// @ts-expect-error
export const enum FeatureFlag {
  FT_EXCHANGE_FLOW = "ft_exchange_fow",
  FT_EXCHANGE_PAIR_PAYMENT_SYSTEMS = "ft_exchange_pair_payment_systems",
  FT_SELL_FLOW = "ft_sell_fow",
}

export const defaultFlags: Record<FeatureFlag, boolean> = {
  [FeatureFlag.FT_EXCHANGE_FLOW]: false,
  [FeatureFlag.FT_EXCHANGE_PAIR_PAYMENT_SYSTEMS]: true,
  [FeatureFlag.FT_SELL_FLOW]: true,
};
